__turbopack_context__.v({
  "breadcrumbs": "style-module-scss-module__GlomcW__breadcrumbs",
  "current": "style-module-scss-module__GlomcW__current",
  "item": "style-module-scss-module__GlomcW__item",
  "link": "style-module-scss-module__GlomcW__link",
  "list": "style-module-scss-module__GlomcW__list",
  "truncatedItem": "style-module-scss-module__GlomcW__truncatedItem",
  "truncatedLink": "style-module-scss-module__GlomcW__truncatedLink",
});
